module.exports = __webpack_public_path__ + "media/images/pub/bkg-85172814a1238a7d8cff4365ae483605.jpg";